import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static targets = ["dateInput", "itemsContainer", "itemTemplate"]

  connect() {
    this.flatpickrInstances = []
    if (this.hasItemsContainerTarget) {
      this.nextItemIndex = this.itemsContainerTarget.querySelectorAll("[data-item-row]").length
    }
    this.initFlatpickr()
  }

  disconnect() {
    this.flatpickrInstances?.forEach((instance) => instance.destroy())
    this.flatpickrInstances = []
  }

  initFlatpickr() {
    this.dateInputTargets.forEach((input) => {
      if (input.dataset.flatpickrInitialized === "true") return

      const appendTo = input.closest("dialog") || document.body
      this.flatpickrInstances.push(flatpickr(input, {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "m-d-Y",
        altInputClass: "input input-bordered w-full",
        allowInput: true,
        disableMobile: true,
        appendTo
      }))
      input.dataset.flatpickrInitialized = "true"
    })
  }

  removeDocumentRow(event) {
    event.preventDefault()
    const row = event.target.closest("[data-document-row]")
    if (!row) return

    const removeField = row.querySelector("[data-remove-document-id]")
    if (removeField) {
      removeField.disabled = false
    }

    row.classList.add("hidden")
  }

  addItemRow(event) {
    event.preventDefault()
    if (!this.hasItemsContainerTarget || !this.hasItemTemplateTarget) return

    const index = this.nextItemIndex
    const html = this.itemTemplateTarget.innerHTML.replace(/NEW_ITEM/g, index)
    this.itemsContainerTarget.insertAdjacentHTML("beforeend", html)
    this.nextItemIndex += 1
  }

  removeItemRow(event) {
    event.preventDefault()
    const row = event.target.closest("[data-item-row]")
    if (!row) return

    const destroyField = row.querySelector("[data-destroy-field]")
    if (destroyField) {
      destroyField.value = "1"
      row.classList.add("hidden")
      return
    }

    row.remove()
  }
}
